import * as THREE from 'three'

export const calculateTranslateVec = (edges) => {
  const translateVec = new THREE.Vector2(0, 0)
  Object.values(edges).forEach((v) => translateVec.add(v))
  translateVec.divideScalar(Object.keys(edges).length)
  return translateVec
}
